import { Injectable } from '@angular/core';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { Observable, forkJoin } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IndexeddbService {

  constructor(private dbService: NgxIndexedDBService) { }

  /******** With Reference Number File ************/
  addFile(fileName: string, filePath: string, referenceNumber: string, mandateDocumentId: any, mandateId: any) {
    const fileData = { fileName, filePath, referenceNumber, mandateDocumentId, mandateId };
    return this.dbService.add('files', fileData);
  }
  //Add Multiple Files
  addFiles(files: { fileName: string; filePath: string; referenceNumber: string, mandateDocumentId: any, mandateId: any }[]): Observable<any> {
    const addFileObservables: Observable<any>[] = files.map((file) => {
      return this.addFile(file.fileName, file.filePath, file.referenceNumber, file.mandateDocumentId, file.mandateId);
    });
    return forkJoin(addFileObservables);
  }
  //Get All Files
  getAllFiles(): Observable<any[]> {
    return this.dbService.getAll('files');
  }
  //Delete Single File
  deleteFileById(id: number): Observable<any> {
    return this.dbService.delete('files', id);
  }
  //Clear All Files
  clearAllFiles(): Observable<any> {
    return this.dbService.clear('files');
  }

  /************* Mandate Batch ID ***********/
  addMandate(mandateId: string, batchId: string): Observable<any> {
    const mandateData = { mandateId, batchId };
    return this.dbService.add('mandate', mandateData);
  }

  //getMandate
  getMandateAll(): Observable<any> {
    return this.dbService.getAll('mandate');
  }

  getMandateById(id: any): Observable<any> {
    return this.dbService.getByKey('mandate', id);
  }

  //clearMandate
  clearAllMandate(): Observable<any> {
    return this.dbService.clear('mandate');
  }

  /************* Upload Failure Files ***********/
  addFailureFile(file: Blob): Observable<any> {
    const fileData = { file };
    return this.dbService.add('failureFiles', fileData);
  }
  addFailureFiles(files: Blob[]): Observable<any> {
    const addFailureFileObservables: Observable<any>[] = files.map((file) => {
      return this.addFailureFile(file);
    });
    return forkJoin(addFailureFileObservables);
  }
  getAllFailureFiles(): Observable<any[]> {
    return this.dbService.getAll('failureFiles');
  }
  deleteFailureFileById(id: number): Observable<any> {
    return this.dbService.delete('failureFiles', id);
  }
  clearAllFailureFiles(): Observable<any> {
    return this.dbService.clear('failureFiles');
  }

  /************* Multiple Files Store ***********/
  addMultiFile(file: Blob): Observable<any> {
    const fileData = { file };
    return this.dbService.add('multiFiles', fileData);
  }
  addMultiFiles(files: Blob[]): Observable<any> {
    const addFileObservables: Observable<any>[] = files.map((file) => {
      return this.addMultiFile(file);
    });
    return forkJoin(addFileObservables);
  }
  getAllMultiFiles(): Observable<any[]> {
    return this.dbService.getAll('multiFiles');
  }
  deleteMultiFileById(id: number): Observable<any> {
    return this.dbService.delete('multiFiles', id);
  }
  clearAllMultiFiles(): Observable<any> {
    return this.dbService.clear('multiFiles');
  }
}
